import { gql } from "@apollo/client";

export const FETCH_FEATURE_FLAGS = gql`
  query FetchFeatureFlags {
    me {
      id
      featureFlags
    }
  }
`;
